<template>
    <div>
        <ModalCommon :id="`configModalRule-${config?.id ?? ''}`" :config="config" @save="formSubmit()" @close="handleClose()">
            <form class="needs-validation" autocomplete="off" @submit.prevent="formSubmit">
                <div class="form-group row">
                    <label class="col-sm-2 mw--form" for="validationCustom05">配置 <span class="text-danger">*</span></label>
                    <div class="col-sm-5">
                        <Multiselect
                            :id="`select-option`"
                            :value.sync="dataForm.option"
                            :options="listDataMasterOption"
                            :config.sync="configForm.configFieldOption"
                            @remove="handleValidate(configForm.configFieldOption)"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-2 mw--form" for="validationCustom05">区分 <span class="text-danger">*</span></label>
                    <div class="col-sm-5">
                        <Multiselect
                            :id="`select-classification`"
                            :value.sync="dataForm.classification"
                            :options="listDataMasterClassic"
                            :config.sync="configForm.configFieldClassic"
                            @remove="handleValidate(configForm.configFieldClassic)"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-2 mw--form" for="validationCustom05">デフォルト有無 </label>
                    <div class="col-sm-10">
                        <InputCheckBox :model.sync="dataForm.is_default" :id="`is_default1`" :value="dataForm.is_default" :label="``" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 mw--form" for="validationCustom05">{{ $t('screenRule.settingFomulator') }}</label>
                    <div class="col-sm-10">
                        <b-button @click="visibleFormulator = !visibleFormulator">{{
                            `${visibleFormulator ? `${$t('screenRule.hiddenSetting')}` : `${$t('screenRule.showSetting')}`}`
                        }}</b-button>
                    </div>
                </div>
                <b-collapse v-model="visibleFormulator">
                    <div class="form-group row">
                        <label class="col-sm-2 mw--form" for="validationCustom05"></label>
                        <div class="col-sm-10">
                            <div class="row">
                                <div class="col-sm-6 pr-0">
                                    <textarea rows="25" class="form-control" ref="myTextarea" v-model="dataForm.logic_formula"></textarea>
                                </div>
                                <div class="col-sm-6 pr-0">
                                    <div style="border-bottom: 1px solid #ddd">
                                        <p>{{ $t('screenRule.operatorSetting') }}</p>
                                        <ul style="list-style: none; padding-left: 0">
                                            <li
                                                v-for="item in IF_CONDITION"
                                                :key="item"
                                                @click="insertTextAtCursor(item, 'condition')"
                                                class="itemList"
                                            >
                                                {{ item }}
                                            </li>
                                        </ul>
                                    </div>
                                    <div style="border-bottom: 1px solid #ddd">
                                        <p class="mt-3">{{ $t('screenRule.titlePlatform') }}</p>
                                        <ul style="list-style: none; padding-left: 0">
                                            <li
                                                v-for="item in TITLE_PLATFORM"
                                                :key="item.id"
                                                @click="insertTextAtCursor(item, 'platform')"
                                                class="itemList"
                                            >
                                                {{ item.title }}
                                            </li>
                                        </ul>
                                    </div>
                                    <div>
                                        <p class="mt-3">{{ $t('screenRule.detailRule') }}</p>
                                        <InputText
                                            class="mb-3"
                                            :model.sync="searchDetailRegulation"
                                            :config="{
                                                placeholder: $t('screenRule.placeholderSearchRule'),
                                                error: false
                                            }"
                                        />
                                        <div style="height: 500px; overflow-y: auto">
                                            <div v-for="(item, idx) in filteredRuleGroup" :key="idx">
                                                <div
                                                    v-if="[1, 2].includes(item.type)"
                                                    class="p-3 mb-3"
                                                    style="box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px"
                                                >
                                                    <p class="text-center" style="font-weight: 700">{{ item.name_type }}</p>
                                                    <ul style="list-style: none; padding-left: 0">
                                                        <li
                                                            v-for="jtem in item.rules"
                                                            :key="`${item.id}-${jtem.id}`"
                                                            @click="insertTextAtCursor(jtem, 'rule')"
                                                            class="itemList"
                                                        >
                                                            {{ jtem.rule }}
                                                        </li>
                                                    </ul>
                                                </div>

                                                <template v-else-if="item.type === 3">
                                                    <div
                                                        v-for="(platform, pIdx) in item.rules"
                                                        :key="pIdx"
                                                        style="box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px"
                                                        class="p-3 mb-3"
                                                    >
                                                        <p class="text-center mb-0" style="font-weight: 700">
                                                            {{ platform.platform_name }}
                                                        </p>
                                                        <ul style="list-style: none; padding-left: 0" class="mt-2 text-left text-body">
                                                            <li
                                                                v-for="jtem in platform.rules"
                                                                :key="jtem.id"
                                                                @click="insertTextAtCursor(jtem, 'rule')"
                                                                class="itemList"
                                                            >
                                                                {{ jtem.rule }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-collapse>
                <div class="form-group row">
                    <label class="col-sm-2 mw--form" for="validationCustom05">条文・細則<span class="text-danger">*</span></label>
                    <div class="col-sm-10">
                        <div class="row">
                            <div class="col-sm-6 pr-0">
                                <Editor
                                    v-if="isVisibleEditor"
                                    :model.sync="dataForm.detail"
                                    :configError.sync="configForm.configFieldDetail"
                                    @init="onEditorInit"
                                    @change="handleValidate(configForm.configFieldDetail)"
                                />
                            </div>
                            <div class="col-sm-6 pr-0">
                                <ul style="list-style: none; padding-left: 0">
                                    <li
                                        @click="handleCopy(item)"
                                        style="border: 1px solid #ddd; display: inline-block; margin-right: 8px; margin-bottom: 8px; cursor: pointer"
                                        v-for="item in shortCode"
                                        :key="item"
                                    >
                                        {{ item }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ModalCommon>
    </div>
</template>

<script>
import ModalCommon from '@/components/Modal/main.vue';
import Editor from '@/components/Editor/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';

import { TITLE_PLATFORM } from '@/config/var-common';
import { masterMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { validateField, validateAllField } from '@/utils/validate';
import { configForm, shortCode, initDataForm, IF_CONDITION, groupRulesByType } from './index';
import { InputCheckBox, InputText } from '@/components/Input';

export default {
    name: 'ModalRule',
    components: {
        ModalCommon,
        Editor,
        Multiselect,
        InputCheckBox,
        InputText
    },
    props: {
        dataRule: {
            type: Object,
            default: () => null
        },
        listDataMasterOption: {
            type: Array,
            default: () => []
        },
        listDataMasterClassic: {
            type: Array,
            default: () => []
        },
        listRuleAll: {
            type: Array,
            default: () => []
        },
        config: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            shortCode: shortCode,
            dataForm: this.dataRule,
            configForm: configForm(),
            IF_CONDITION: IF_CONDITION,
            TITLE_PLATFORM: TITLE_PLATFORM,
            editorObj: null,
            isVisibleEditor: false,
            isLoading: false,
            visibleFormulator: false,
            searchDetailRegulation: '',
            listRuleGroup: [],
            listIdRuleFormula: []
        };
    },
    computed: {
        filteredRuleGroup() {
            const keyword = this.searchDetailRegulation;
            if (!keyword) return this.listRuleGroup;
            const lowerKeyword = keyword.toLowerCase();
            return this.listRuleGroup.reduce((acc, group) => {
                const matchNameType = group.name_type && group.name_type.toLowerCase().includes(lowerKeyword);
                if (group.type === 1 || group.type === 2) {
                    const filteredRules = group.rules.filter((r) => r.rule && r.rule.toLowerCase().includes(lowerKeyword));
                    const rulesToKeep = matchNameType ? group.rules : filteredRules;
                    if (rulesToKeep.length > 0) {
                        acc.push({ ...group, rules: rulesToKeep });
                    }
                } else if (group.type === 3) {
                    const filteredPlatforms = group.rules.reduce((pAcc, platform) => {
                        const matchPlatformName = platform.platform_name && platform.platform_name.toLowerCase().includes(lowerKeyword);
                        const filteredPlatformRules = platform.rules.filter((r) => r.rule && r.rule.toLowerCase().includes(lowerKeyword));
                        const platformRulesToKeep = matchNameType || matchPlatformName ? platform.rules : filteredPlatformRules;
                        if (platformRulesToKeep.length > 0) {
                            pAcc.push({ ...platform, rules: platformRulesToKeep });
                        }
                        return pAcc;
                    }, []);
                    if (filteredPlatforms.length > 0) {
                        acc.push({ ...group, rules: filteredPlatforms });
                    }
                }

                return acc;
            }, []);
        }
    },
    methods: {
        ...masterMethods,

        onEditorInit(editor) {
            this.editorObj = editor;
        },

        handleCopy(data) {
            this.editorObj.insertContent(data);
        },

        insertTextAtCursor(data, type) {
            const textarea = this.$refs.myTextarea;
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const value = this.dataForm.logic_formula;
            let insertText = '';
            switch (type) {
                case 'rule':
                    insertText = data.rule;
                    this.listIdRuleFormula.push(data.id);
                    break;
                case 'condition':
                    insertText = ` ${data} `;
                    break;
                case 'platform':
                    insertText = data.title;
                    break;
            }
            this.dataForm.logic_formula = value.slice(0, start) + insertText + value.slice(end);
            this.$nextTick(() => {
                textarea.selectionStart = textarea.selectionEnd = start + insertText.length;
                textarea.focus();
            });
        },

        removeHtmlTags(str) {
            return str.replace(/<\/?[^>]+(>|$)/g, '');
        },

        handleClose() {
            this.config.model = false;
            this.dataForm = initDataForm();
            this.configForm = configForm();
        },

        handleValidate(config) {
            validateField(config);
        },

        escapeRegex(str) {
            return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        },
        replaceRulesWithIds(input, ruleList, listPlatform) {
            let result = input;
            ruleList.forEach(({ id, rule }) => {
                if (this.listIdRuleFormula.includes(id)) {
                    result = result.split(rule).join(`{${id}}`);
                }
            });
            listPlatform.forEach(({ title, pf_title }) => {
                result = result.split(title).join(`{${pf_title}}`);
            });
            return result;
        },

        replaceIdsWithRules(input, rules, platforms) {
            return input.replace(/\{([^}]+)\}/g, (_, key) => {
                if (/^\d+$/.test(key)) {
                    this.listIdRuleFormula.push(Number(key));
                    const ruleItem = rules.find((r) => r.id === Number(key));
                    return ruleItem ? ruleItem.rule : `{${key}}`;
                }
                const platformItem = platforms.find((p) => p.pf_title === key);
                return platformItem ? platformItem.title : `{${key}}`;
            });
        },

        formSubmit() {
            let checkValidate = validateAllField(this.configForm);
            if (!checkValidate || this.isLoading) return;
            this.isLoading = true;
            let object = JSON.parse(JSON.stringify(this.dataForm));
            object.detail = this.removeHtmlTags(object.detail);
            object.option = {
                id: object.option.id
            };
            object.classification = {
                id: object.classification.id
            };
            object.logic_formula = this.replaceRulesWithIds(object.logic_formula, this.listRuleAll, this.TITLE_PLATFORM).trim();
            if (object.id) {
                this.updateRule2(object).then((data) => {
                    this.isLoading = false;
                    if (data.code !== 200) {
                        showMessage(data.code, this.$bvToast, this.$t(data.message));
                        return;
                    }
                    showMessage(data.code, this.$bvToast, '更新されました。');
                    this.handleClose();
                    this.$emit('refresh');
                });
            } else {
                this.createRule2(object).then((data) => {
                    this.isLoading = false;
                    if (data.code !== 200) {
                        showMessage(data.code, this.$bvToast, this.$t(data.message));
                        return;
                    }
                    showMessage(data.code, this.$bvToast, '登録されました。');
                    this.handleClose();
                    this.$emit('refresh');
                });
            }
            this.listIdRuleFormula = [];
        }
    },
    watch: {
        'config.model': {
            handler: function (newShow) {
                this.visibleFormulator = false;
                if (newShow) {
                    this.listRuleGroup = groupRulesByType(this.listRuleAll);
                    setTimeout(() => {
                        this.isVisibleEditor = true;
                    }, 200);
                } else {
                    this.isVisibleEditor = false;
                }
            }
        },

        dataRule: {
            handler: function (newData) {
                this.dataForm = {
                    ...newData,
                    logic_formula: newData?.logic_formula
                        ? this.replaceIdsWithRules(newData?.logic_formula, this.listRuleAll, this.TITLE_PLATFORM)
                        : ''
                };
                this.config.titleBtnSave = newData?.id ? '保存' : '登録';
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
li.itemList {
    border: 1px solid #ddd;
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 8px;
    cursor: pointer;
    padding: 2px 5px;
}
</style>
